import { Box, Typography, useTheme } from '@mui/material';
import { CustomTheme } from '../contexts/theme.context';

export const Home = () => {
  const theme = useTheme<CustomTheme>();

  return (
    <Box display="flex" flexDirection="column" height="100%" style={{ paddingTop: '20px' }}>
      <Box display="flex" flexDirection="row">
        <Box sx={{ height: '100px' }}>
          <img src={theme.companyLogo} style={{ maxHeight: '100%' }} />
        </Box>
        <Box display="flex" flexDirection="column">
          <Box>
            <Typography variant="h3" color="primary">
              {theme.companyName}
            </Typography>
          </Box>
          <Box>
            <Typography variant="h4" color="secondary">
              Manage and Maintain Feature Codes for a Standardized Environment
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box flexShrink={1} style={{ marginLeft: '20px', height: '666px' }}>
        <img src={'/home-page.jpg'} style={{ height: '100%' }} />
      </Box>
    </Box>
  );
};
